document.addEventListener("DOMContentLoaded", function () {
  var checkoutButton = document.getElementById("checkoutympButton");

  if (checkoutButton) {
    checkoutButton.addEventListener("click", function (event) {
      // Função para verificar se um número é múltiplo de 3
      function isMultipleOfThree(num) {
        return num % 3 === 0;
      }

      // Função para obter a quantidade total no carrinho
      function getTotalQuantity() {
        var totalQuantity = 0;

        var cartItems = window.Shopify.cart.items;
        if (cartItems) {
          cartItems.forEach(function (item) {
            totalQuantity += item.quantity;
          });
        }

        return totalQuantity;
      }

      var totalQuantity = getTotalQuantity();

      if (!isMultipleOfThree(totalQuantity)) {
        event.preventDefault();
        alert(
          "A quantidade total no carrinho deve ser um múltiplo de 3 para finalizar a compra."
        );
      }
    });
  }
});
